// extracted by mini-css-extract-plugin
export default {"backToProjectBtn":"BackToProjectsButton_backToProjectBtn__mBsmI","backToProjectButtonContainer":"BackToProjectsButton_backToProjectButtonContainer__31cSZ"};